// React
import React, {useEffect} from 'react'
// React Router
import {Route, Routes} from "react-router-dom"
// Pages
import {Layout} from "@App/Pages/Layout"
import {useSelector} from "react-redux";
import {State, store} from "@App/state";
import i18n from "@App/utils/i18n";
import {Inspection} from "@App/Pages/Inspection";
import {BrakesService} from "@App/Pages/BrakesService";
import {Oilchange} from "@App/Pages/Oilchange";
import {Garages} from "@App/Pages/Common/Garages";
import {Profile} from "@App/Pages/Common/Profile";
import {Contact} from "@App/Pages/Common/Contact";
import {Summary} from "@App/Pages/Common/Summary";
import {useNavigateWithQueryParams} from "@App/hooks/useNavigateWithQueryParams";
import {Certificate} from "@App/Pages/Certificate";
import {Glass} from "@App/Pages/Glass";
import {Appointment} from "@App/Pages/Appointment";
import {ClutchService} from "@App/Pages/ClutchService";
import {Timingbelt} from "@App/Pages/Timingbelt";
import {RedirectToCatchAll} from "@App/Pages/Common/RedirectToCatchAll";
import {TrailerHitch} from "@App/Pages/TrailerHitch";
import {AirConditioning} from "@App/Pages/AirConditioning";
import {Wheelchange} from "@App/Pages/Wheelchange";
import {BrakeFluidService} from "@App/Pages/BrakeFluidService";
import {SparkPlugService} from "@App/Pages/SparkPlugService";

export function RepareoFunnel() {
    const {navigateWithQuery} = useNavigateWithQueryParams()

    const organization = useSelector((state: State) => state.orders.organization)

    // change the language
    useEffect(() => {
        i18n.changeLanguage(organization.settings.language)
    }, [])

    const submitGarage = () => {
        // use the current store state to get the service
        // because the useSelector hook is not getting updated on time
        navigateWithQuery(`/${store.getState().orders.service.slug}/werkstatt`)
    }

    const submitSlot = () => {
        // use the current store state to get the service
        // because the useSelector hook is not getting updated on time
        navigateWithQuery(`/${store.getState().orders.service.slug}/werkstatt/buchen`)
    }

    const submitInquiry = () => {
        // use the current store state to get the service
        // because the useSelector hook is not getting updated on time
        navigateWithQuery(`/${store.getState().orders.service.slug}/werkstatt/buchen/erfolgreich`)
    }

    return (
        <Routes>
            <Route path={"/"} element={<Layout/>}>
                {/* checkout */}
                <Route path={":serviceSlug/werkstaetten"}
                       element={<Garages onSubmit={submitGarage}/>}/>
                <Route path={":serviceSlug/werkstatt"}
                       element={<Profile onSubmit={submitSlot}/>}/>
                <Route path={":serviceSlug/werkstatt/buchen"}
                       element={<Contact
                           onSubmit={submitInquiry}/>}/>
                <Route path={":serviceSlug/werkstatt/buchen/erfolgreich"}
                       element={<Summary/>}/>
                {/* funnels */}
                <Route path={"inspektion/*"}
                       element={<Inspection/>}/>
                <Route path={"hu-au-tuev/*"}
                       element={<Certificate/>}/>
                <Route path={"bremsenwechsel/*"}
                       element={<BrakesService/>}/>
                <Route path={"oelwechsel/*"}
                       element={<Oilchange/>}/>
                <Route path={"kupplung/*"}
                       element={<ClutchService/>}/>
                <Route path={"zahnriemenwechsel/*"}
                       element={<Timingbelt/>}/>
                <Route path={"autoglas-reparatur/*"}
                       element={<Glass/>}/>
                <Route path={"anhaengerkupplung-nachruesten/*"}
                       element={<TrailerHitch/>}/>
                <Route path={"klimaservice/*"}
                       element={<AirConditioning/>}/>
                <Route path={"raederwechsel/*"}
                       element={<Wheelchange/>}/>
                <Route path={"bremsfluessigkeit-wechseln/*"}
                       element={<BrakeFluidService/>}/>
                <Route path={"zuendkerzen-wechseln/*"}
                       element={<SparkPlugService/>}/>
                <Route path={"termin/*"}
                       element={<Appointment/>}/>
                {/* catch all */}
                <Route path={"/"} element={<RedirectToCatchAll/>}/>
                <Route path={"*"} element={<RedirectToCatchAll/>}/>
            </Route>
        </Routes>
    )
}
